import { AppState } from 'types';
import { Language } from 'store/state';

export function changeLanguageAction(state: AppState, payload: Partial<AppState>) {
	return {
		...state,
		language: {
			...state.language,
			...payload.language
		}
	};
}

export function translationsAction(state: AppState, payload: Partial<AppState>) {
	const LANG = payload.language?.language as Language;
	return {
		...state,
		language: {
			...state.language,
			translations: {
				...state.language.translations,
				[LANG]: {
					...state.language.translations[LANG],
					...payload.language?.translations
				}
			}
		}
	};
}
